import { forwardRef } from "react";
import { cn } from "@/lib/utils";
import { useFieldAria } from "./field-context";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  invalid?: boolean;
};

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, ...props }, ref) => {
    const { describedBy: ctxDescribedBy, invalid: ctxInvalid } = useFieldAria();
    const explicitDescribedBy = props["aria-describedby"];
    const ariaDescribedBy = explicitDescribedBy ?? ctxDescribedBy;
    const ariaInvalid = invalid ?? ctxInvalid;
    return (
      <textarea
        ref={ref}
        aria-invalid={ariaInvalid || undefined}
        aria-describedby={ariaDescribedBy}
        className={cn(
          "min-h-[3.5rem] w-full rounded-xl border border-border bg-foreground/[0.03] px-3 py-2 text-sm text-foreground transition placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring",
          (invalid || ariaInvalid) && "border-destructive focus:ring-destructive",
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";
